"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectSpread4 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Wapp = require("wapplr-react/dist/common/Wapp");

var _getUtils = _interopRequireDefault(require("wapplr-react/dist/common/Wapp/getUtils"));

var _withMaterial = require("configurator-studio-arkitekter-components/dist/common/components/Template/withMaterial");

var _context2 = _interopRequireDefault(require("configurator-studio-arkitekter-components/dist/common/components/Post/context"));

var _context3 = _interopRequireDefault(require("configurator-studio-arkitekter-components/dist/common/components/App/context"));

var _Menu = _interopRequireDefault(require("configurator-studio-arkitekter-components/dist/common/components/Menu"));

var _SelectPage = _interopRequireDefault(require("../SelectPage"));

var _Home = _interopRequireDefault(require("../Home"));

var _Summary = _interopRequireDefault(require("../Summary"));

var _materialStyle = _interopRequireDefault(require("./materialStyle"));

var _context4 = _interopRequireDefault(require("./context"));

var _utils = require("./utils");

var _menu = _interopRequireDefault(require("../App/menu"));

var style = require("./style_css.js")["default"];

function Configurator(props) {
  var _selectedModel$steps, _step$options, _selectedModel$steps$, _selectedModel$steps$2, _selectedModel$steps2, _data$models, _data$settings, _data$settings$models, _data$settings2, _data$settings2$model, _data$settings3, _data$settings3$confi, _data$settings4, _data$settings4$confi, _step$layer;

  var context = (0, _react.useContext)(_Wapp.WappContext);
  var postContext = (0, _react.useContext)(_context2["default"]);
  var appContext = (0, _react.useContext)(_context3["default"]);
  var wapp = context.wapp,
      res = context.res;
  var routes = appContext.routes,
      messages = appContext.messages,
      labels = appContext.labels,
      storage = appContext.storage;
  var onChange = props.onChange;
  wapp.styles.use(style);

  var _getDataAndInitialCon = (0, _utils.getDataAndInitialConfiguration)({
    context: context,
    appContext: appContext,
    postContext: postContext,
    initialConfiguration: props.initialConfiguration
  }),
      initialConfiguration = _getDataAndInitialCon.initialConfiguration,
      data = _getDataAndInitialCon.data;

  var _useState = (0, _react.useState)(initialConfiguration),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      configuration = _useState2[0],
      _setConfiguration = _useState2[1];

  var isAuthorOrAdmin = (0, _utils.getIsAuthorOrAdmin)({
    appContext: appContext,
    postContext: postContext
  });

  if (isAuthorOrAdmin && wapp.target === "web") {
    console.log("[CSAA] Initialized data and configuration ", data, configuration);
  }

  var configuratorContext = {
    data: data,
    configuration: configuration,
    setConfiguration: function setConfiguration(newConfiguration) {
      return (0, _utils.setConfiguration)({
        newConfiguration: newConfiguration,
        configuration: configuration,
        data: data,
        isAuthorOrAdmin: isAuthorOrAdmin,
        onChange: onChange,
        _setConfiguration: _setConfiguration,
        storage: storage
      });
    },
    translate: function translate(a) {
      return (0, _utils.translate)(a, configuration.selectedLang);
    },
    getPrice: function getPrice(a) {
      return (0, _utils.getPrice)(a, data, configuration.selectedLang);
    },
    getDayPeriodImage: function getDayPeriodImage(a) {
      var dayPeriod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : configuration.selectedDayPeriod;
      return (0, _utils.getDayPeriodImage)(a, dayPeriod);
    }
  };
  var requestPath = res.wappResponse.route.requestPath;
  var params = res.wappResponse.route.params;
  var selectedModel = data.models && data.models.find(function (m) {
    return m.key === configuration.selectedModel;
  }) && data.models.find(function (m) {
    return m.key === configuration.selectedModel;
  });
  var stepI = -1;
  var questionI = -1;
  var step = selectedModel !== null && selectedModel !== void 0 && (_selectedModel$steps = selectedModel.steps) !== null && _selectedModel$steps !== void 0 && _selectedModel$steps.length && params.step ? selectedModel.steps.find(function (step, i) {
    if (step.key === params.step) {
      stepI = i;
      return true;
    }

    return false;
  }) : null;
  var question = step !== null && step !== void 0 && (_step$options = step.options) !== null && _step$options !== void 0 && _step$options.length && params.question ? step.options.find(function (question, i) {
    if (question.key === params.question) {
      questionI = i;
      return true;
    }

    return false;
  }) : null;
  var nextQuestion = step && step.options[questionI + 1] ? {
    step: step,
    question: step.options[questionI + 1]
  } : selectedModel !== null && selectedModel !== void 0 && selectedModel.steps && selectedModel.steps[stepI + 1] && (_selectedModel$steps$ = selectedModel.steps[stepI + 1].options) !== null && _selectedModel$steps$ !== void 0 && _selectedModel$steps$.length ? {
    step: selectedModel.steps[stepI + 1],
    question: selectedModel.steps[stepI + 1].options[0]
  } : {};
  var prevQuestion = step && step.options[questionI - 1] ? {
    step: step,
    question: step.options[questionI - 1]
  } : selectedModel !== null && selectedModel !== void 0 && selectedModel.steps && selectedModel.steps[stepI - 1] && (_selectedModel$steps$2 = selectedModel.steps[stepI - 1].options) !== null && _selectedModel$steps$2 !== void 0 && _selectedModel$steps$2.length ? {
    step: selectedModel.steps[stepI - 1],
    question: selectedModel.steps[stepI - 1].options[selectedModel.steps[stepI - 1].options.length - 1]
  } : {};
  var firstQuestion = selectedModel !== null && selectedModel !== void 0 && (_selectedModel$steps2 = selectedModel.steps) !== null && _selectedModel$steps2 !== void 0 && _selectedModel$steps2.length && selectedModel !== null && selectedModel !== void 0 && selectedModel.steps[0] && selectedModel !== null && selectedModel !== void 0 && selectedModel.steps[0].options && selectedModel !== null && selectedModel !== void 0 && selectedModel.steps[0].options[0] ? {
    step: selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.steps[0],
    question: selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.steps[0].options[0]
  } : {};

  function _onClick2(_x, _x2) {
    return _onClick.apply(this, arguments);
  }

  function _onClick() {
    _onClick = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(e, menu) {
      var _appContext$template2;

      var href;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              href = menu.href;

              if (!((_appContext$template2 = appContext.template) !== null && _appContext$template2 !== void 0 && _appContext$template2.actions)) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return appContext.template.actions.scrollTop();

            case 4:
              wapp.client.history.push((0, _objectSpread4["default"])({
                search: "",
                hash: ""
              }, wapp.client.history.parsePath(href)));
              e.preventDefault();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _onClick.apply(this, arguments);
  }

  (0, _react.useEffect)(function () {
    var utils = (0, _getUtils["default"])(context);
    var initialState = typeof window !== "undefined" && window[wapp.config.appStateName] || {
      req: {
        timestamp: Date.now()
      }
    };
    var firstRender = utils.getGlobalState().req.timestamp === initialState.req.timestamp || wapp.target === "node";

    if (firstRender) {
      var foundRoute = requestPath === "/" || requestPath === routes.modelsRoute || selectedModel !== null && selectedModel !== void 0 && selectedModel.key && requestPath.startsWith(routes.modelsRoute + "/" + selectedModel.key) && !step || selectedModel !== null && selectedModel !== void 0 && selectedModel.key && requestPath === routes.modelsRoute + "/" + selectedModel.key + routes.collectionsRoute || selectedModel !== null && selectedModel !== void 0 && selectedModel.key && requestPath.startsWith(routes.modelsRoute + "/" + selectedModel.key) && step && question || requestPath === routes.summaryRoute ? requestPath : "";

      if (foundRoute && requestPath !== "/") {
        setTimeout(function () {
          var _appContext$template;

          if ((_appContext$template = appContext.template) !== null && _appContext$template !== void 0 && _appContext$template.actions) {
            if (!appContext.template.actions.getState().open && !appContext.template.actions.getState().narrow) {
              appContext.template.actions.drawerOpen();
            }
          }
        });
      }
    }
  }, []);
  var hideModels = ((_data$models = data.models) === null || _data$models === void 0 ? void 0 : _data$models.length) === 1 && selectedModel && data.models[0].key === selectedModel.key || !data.models || data.models && data.models.length === 0;
  var hideCollections = !selectedModel || selectedModel && !selectedModel.collections || selectedModel && selectedModel.collections && selectedModel.collections.length === 0 || selectedModel && selectedModel.collections && selectedModel.collections.length === 1;
  var firstNextButtonLabel = firstQuestion.step && firstQuestion.question ? configuratorContext.translate(labels.nextLabel) + " | " + configuratorContext.translate(firstQuestion.step.name) + " > " + configuratorContext.translate(firstQuestion.question.name) : configuratorContext.translate(labels.nextLabel) + " | " + configuratorContext.translate(labels.summaryLabel);
  var firstNextButtonHref = firstQuestion.step && firstQuestion.question ? routes.modelsRoute + "/" + selectedModel.key + "/" + firstQuestion.step.key + "/" + firstQuestion.question.key : routes.summaryRoute;
  return /*#__PURE__*/_react["default"].createElement(_context4["default"].Provider, {
    value: configuratorContext
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.configurator
  }, requestPath === "/" ? /*#__PURE__*/_react["default"].createElement(_Home["default"], null) : null, requestPath === routes.modelsRoute ? /*#__PURE__*/_react["default"].createElement(_SelectPage["default"], {
    data: data.models,
    title: (_data$settings = data.settings) === null || _data$settings === void 0 ? void 0 : (_data$settings$models = _data$settings.models_settings) === null || _data$settings$models === void 0 ? void 0 : _data$settings$models.models_name,
    description: (_data$settings2 = data.settings) === null || _data$settings2 === void 0 ? void 0 : (_data$settings2$model = _data$settings2.models_settings) === null || _data$settings2$model === void 0 ? void 0 : _data$settings2$model.models_description,
    value: configuration.selectedModel,
    onChange: function onChange(data) {
      return configuratorContext.setConfiguration((0, _objectSpread4["default"])((0, _objectSpread4["default"])({}, configuration), {}, {
        steps: null,
        selectedCollection: null,
        selectedModel: data
      }));
    },
    notFoundText: configuratorContext.translate(messages.notFoundModel),
    nextButtonLabel: hideCollections ? firstNextButtonLabel : configuratorContext.translate(labels.nextLabel) + " | " + configuratorContext.translate(labels.collectionsLabel),
    nextButtonProps: {
      onClick: function onClick(e) {
        return selectedModel !== null && selectedModel !== void 0 && selectedModel.key ? _onClick2(e, {
          href: hideCollections ? firstNextButtonHref : routes.modelsRoute + "/" + selectedModel.key + routes.collectionsRoute
        }) : null;
      },
      disabled: !(selectedModel !== null && selectedModel !== void 0 && selectedModel.key)
    }
  }) : null, selectedModel !== null && selectedModel !== void 0 && selectedModel.key && requestPath.startsWith(routes.modelsRoute + "/" + selectedModel.key) && !step || selectedModel !== null && selectedModel !== void 0 && selectedModel.key && requestPath === routes.modelsRoute + "/" + selectedModel.key + routes.collectionsRoute ? /*#__PURE__*/_react["default"].createElement(_SelectPage["default"], {
    data: (0, _toConsumableArray2["default"])(selectedModel !== null && selectedModel !== void 0 && selectedModel.collections ? selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.collections.map(function (collection) {
      var configuration = (0, _utils.getConfiguration)({
        data: data,
        savedConfiguration: {
          selectedModel: selectedModel.key,
          selectedCollection: collection.key,
          isAuthorOrAdmin: isAuthorOrAdmin
        }
      });
      return (0, _objectSpread4["default"])((0, _objectSpread4["default"])({}, collection), {}, {
        price: configuration === null || configuration === void 0 ? void 0 : configuration.price
      });
    }) : []),
    title: (_data$settings3 = data.settings) === null || _data$settings3 === void 0 ? void 0 : (_data$settings3$confi = _data$settings3.configurations_settings) === null || _data$settings3$confi === void 0 ? void 0 : _data$settings3$confi.configurations_name,
    description: (_data$settings4 = data.settings) === null || _data$settings4 === void 0 ? void 0 : (_data$settings4$confi = _data$settings4.configurations_settings) === null || _data$settings4$confi === void 0 ? void 0 : _data$settings4$confi.configurations_description,
    value: configuration.selectedCollection,
    onChange: function onChange(data) {
      return configuratorContext.setConfiguration((0, _objectSpread4["default"])((0, _objectSpread4["default"])({}, configuration), {}, {
        steps: null,
        selectedCollection: data
      }));
    },
    notFoundText: configuratorContext.translate(messages.notFoundCollection),
    prevButtonLabel: hideModels ? null : configuratorContext.translate(labels.prevLabel) + " | " + configuratorContext.translate(labels.modelsLabel),
    prevButtonProps: {
      onClick: function onClick(e) {
        return _onClick2(e, {
          href: routes.modelsRoute
        });
      }
    },
    nextButtonLabel: firstNextButtonLabel,
    nextButtonProps: {
      onClick: function onClick(e) {
        return _onClick2(e, {
          href: firstNextButtonHref
        });
      }
    },
    ComputedContent: function ComputedContent(props) {
      var item = props.item;
      var menu = (0, _menu["default"])({
        context: context,
        postContext: postContext,
        appContext: appContext,
        configuratorContext: (0, _objectSpread4["default"])((0, _objectSpread4["default"])({}, configuratorContext), {}, {
          configuration: (0, _utils.getConfiguration)({
            data: data,
            savedConfiguration: {
              selectedLang: configuration.selectedLang,
              selectedModel: selectedModel.key,
              selectedCollection: item.key,
              isAuthorOrAdmin: isAuthorOrAdmin
            }
          })
        }),
        showPrice: true
      }).slice(1).map(function (menu) {
        var _menu$items;

        return (0, _objectSpread4["default"])((0, _objectSpread4["default"])({}, menu), {}, {
          items: (_menu$items = menu.items) !== null && _menu$items !== void 0 && _menu$items.length ? menu.items.map(function (mi) {
            return (0, _objectSpread4["default"])((0, _objectSpread4["default"])({}, mi), {}, {
              onClick: function onClick(e) {
                e.preventDefault();
              },
              className: style.cursorDefault
            });
          }) : undefined,
          onClick: function onClick(e) {
            e.preventDefault();
          },
          className: function className() {
            var _menu$items2;

            return (_menu$items2 = menu.items) !== null && _menu$items2 !== void 0 && _menu$items2.length ? null : style.cursorDefault;
          }
        });
      });
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
        menu: menu,
        list: true,
        menuKey: "" + selectedModel.key + "_" + item.key + "_table"
      }));
    }
  }) : null, selectedModel !== null && selectedModel !== void 0 && selectedModel.key && requestPath.startsWith(routes.modelsRoute + "/" + selectedModel.key) && step && question ? /*#__PURE__*/_react["default"].createElement(_SelectPage["default"], {
    data: (0, _toConsumableArray2["default"])(question.options),
    title: step.name,
    description: step.description,
    question: question.name,
    question_description: question.description,
    value: configuration.steps[step.key][question.key].key,
    layers: (_step$layer = step.layer) !== null && _step$layer !== void 0 && _step$layer.length ? [step.layer].concat((0, _toConsumableArray2["default"])(Object.keys(configuration.steps[step.key]).filter(function (questionKey) {
      var _configuration$steps$;

      return (_configuration$steps$ = configuration.steps[step.key][questionKey].layer) === null || _configuration$steps$ === void 0 ? void 0 : _configuration$steps$.length;
    }).map(function (questionKey) {
      return configuration.steps[step.key][questionKey].layer;
    }))) : [],
    layersIndexStorageKey: step.key,
    onChangeDayPeriod: function onChangeDayPeriod(data) {
      return configuratorContext.setConfiguration((0, _objectSpread4["default"])((0, _objectSpread4["default"])({}, configuration), {}, {
        selectedDayPeriod: data
      }));
    },
    onChange: function onChange(data) {
      return configuratorContext.setConfiguration((0, _objectSpread4["default"])((0, _objectSpread4["default"])({}, configuration), {}, {
        steps: (0, _objectSpread4["default"])((0, _objectSpread4["default"])({}, configuration.steps), {}, (0, _defineProperty2["default"])({}, step.key, (0, _objectSpread4["default"])((0, _objectSpread4["default"])({}, configuration.steps[step.key]), {}, (0, _defineProperty2["default"])({}, question.key, question.options.find(function (answer) {
          return answer.key === data;
        }) ? (0, _objectSpread4["default"])({}, question.options.find(function (answer) {
          return answer.key === data;
        })) : (0, _objectSpread4["default"])({}, configuration.steps[step.key][question.key])))))
      }));
    },
    notFoundText: configuratorContext.translate(messages.notFoundAnswer),
    prevButtonLabel: prevQuestion.step && prevQuestion.question ? configuratorContext.translate(labels.prevLabel) + " | " + configuratorContext.translate(prevQuestion.step.name) + " > " + configuratorContext.translate(prevQuestion.question.name) : hideCollections ? hideModels ? null : configuratorContext.translate(labels.prevLabel) + " | " + configuratorContext.translate(labels.modelsLabel) : configuratorContext.translate(labels.prevLabel) + " | " + configuratorContext.translate(labels.collectionsLabel),
    prevButtonProps: {
      onClick: function onClick(e) {
        prevQuestion.step && prevQuestion.question ? _onClick2(e, {
          href: routes.modelsRoute + "/" + selectedModel.key + "/" + prevQuestion.step.key + "/" + prevQuestion.question.key
        }) : hideCollections ? hideModels ? null : _onClick2(e, {
          href: routes.modelsRoute
        }) : _onClick2(e, {
          href: routes.modelsRoute + "/" + selectedModel.key + routes.collectionsRoute
        });
      }
    },
    nextButtonLabel: nextQuestion.step && nextQuestion.question ? configuratorContext.translate(labels.nextLabel) + " | " + configuratorContext.translate(nextQuestion.step.name) + " > " + configuratorContext.translate(nextQuestion.question.name) : configuratorContext.translate(labels.nextLabel) + " | " + configuratorContext.translate(labels.summaryLabel),
    nextButtonProps: {
      onClick: function onClick(e) {
        nextQuestion.step && nextQuestion.question ? _onClick2(e, {
          href: routes.modelsRoute + "/" + selectedModel.key + "/" + nextQuestion.step.key + "/" + nextQuestion.question.key
        }) : _onClick2(e, {
          href: routes.summaryRoute
        });
      }
    }
  }) : null, requestPath === routes.summaryRoute ? /*#__PURE__*/_react["default"].createElement(_Summary["default"], null) : null));
}

var _default = (0, _withMaterial.withMaterialStyles)(_materialStyle["default"], Configurator);

exports["default"] = _default;